/**
 * SW2-2248 — the signature line Resend Inspection sends as.
 *
 * Resend has always taken the inspection group's last line. Inspection review added its reviewer
 * line to that group, last, so with review on a resend went out as a reviewer action: the server
 * refused it (then as a 401, which signed the user out). The review line is skipped, so the
 * choice is what it was before review: the last other line (the inspector's, or a CDOT co-signer's).
 */
export const resendLineType = (lines: { type: string }[]): string =>
  lines.filter((line) => !line.type.startsWith('inspectionReview')).pop()?.type ?? '';
